import React from 'react';

interface AiCreditsCounterProps {
  remaining: number;
  max: number;
  isLowCredits: boolean;
  isLoading?: boolean;
}

export function AiCreditsCounter({ remaining, max, isLowCredits, isLoading = false }: AiCreditsCounterProps) {
  return (
    <div className="flex items-baseline gap-1">
      <span className={`font-bold ${
        isLoading ? 'text-gray-400' :
        isLowCredits ? 'text-red-600' : 'text-gray-900'
      }`}>
        {isLoading ? '...' : (remaining?.toLocaleString() || '0')}
      </span>
      <span className={`text-xs font-medium ${isLoading ? 'text-gray-300' : 'text-gray-400'}`}>
        /{isLoading ? '...' : (max?.toLocaleString() || '0')}
      </span>
    </div>
  );
}